// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { bffBaseUrlForStage, clientIdForStage } from '@ps20-frontend/utils';

export const determineEnvironmentConfig = (
  origin: string = window.location.origin,
): {
  bffBaseUrl: string;
  authorizeUrl: string;
  clientId: string;
  tokenUrl: string;
  revokeUrl: string;
  endSessionUrl: string;
  apigeeActive: boolean;
  scope: string;
} => {
  let authorizeUrl, clientId, tokenUrl, bffBaseUrl, endSessionUrl, revokeUrl, apigeeActive, scope;

  if (origin === 'https://privatschutz-prod.allianz.de') {
    authorizeUrl = 'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/';
    clientId = 'RhHyHA8PZQ9TzeQTOjb8QGjD4h0K0lhW';
    tokenUrl =
      'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/oauth/token';
    bffBaseUrl = 'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/ps20-prod/v1';
    endSessionUrl =
      'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/endsession';
    revokeUrl =
      'https://taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/oauth/revoke';
    apigeeActive = true;
    scope = 'profile az_basic az_role department psb openid amis_id';
  } else if (origin === 'http://localhost') {
    // for Tests
    apigeeActive = false;
  } else {
    authorizeUrl =
      'https://noprod-taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/';
    clientId = clientIdForStage;
    tokenUrl =
      'https://noprod-taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/oauth/token';
    bffBaseUrl = bffBaseUrlForStage;
    endSessionUrl =
      'https://noprod-taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/endsession';
    revokeUrl =
      'https://noprod-taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/itmp-oidc/v1/oauth/revoke';
    scope = 'profile az_basic az_role department psb openid amis_id';
    apigeeActive = true;
  }

  return {
    authorizeUrl,
    clientId,
    tokenUrl,
    bffBaseUrl,
    endSessionUrl,
    revokeUrl,
    apigeeActive,
    scope,
  };
};

const config = determineEnvironmentConfig();

export const environment = {
  production: false,
  apigeeActive: config.apigeeActive,
  authorizeUrl: config.authorizeUrl,
  clientId: config.clientId,
  scope: config.scope,
  appTokenUrl: window.location.origin,
  tokenUrl: config.tokenUrl,
  bffBaseUrl: config.bffBaseUrl,
  endSessionUrl: config.endSessionUrl,
  revokeUrl: config.revokeUrl,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
